
import React from 'react';
import { useTranslation } from 'react-i18next';
import { NeuralChat } from './NeuralChat';
import { Reveal } from './Reveal';

export const Hero: React.FC = () => {
  const { t } = useTranslation();

  return (
    <section className="relative pt-28 pb-20 md:pt-48 md:pb-40 overflow-hidden min-h-screen flex flex-col justify-start items-center bg-white">

      {/* ANIMATED BACKGROUND */}
      <div className="absolute inset-0 z-0 pointer-events-none">
        {/* Subtle moving grid */}
        <div className="absolute inset-0 bg-[linear-gradient(to_right,#80808008_1px,transparent_1px),linear-gradient(to_bottom,#80808008_1px,transparent_1px)] bg-[size:40px_40px] animate-grid-move"></div>

        {/* Radial glow for depth */}
        <div className="absolute inset-0 bg-[radial-gradient(circle_800px_at_50%_50%,transparent,white)]"></div>

        {/* Floating gradient orb for subtle color */}
        <div className="absolute top-[-20%] left-[-10%] w-[600px] h-[600px] bg-teal-100/20 rounded-full blur-[100px] animate-pulse-slow"></div>
      </div>

      <div className="max-w-4xl mx-auto px-6 relative z-10 w-full">

        <div className="flex flex-col items-center text-center">

          <Reveal>
            <div className="inline-flex items-center gap-3 mb-8 md:mb-12 opacity-0 animate-[fadeIn_1s_ease-out_forwards]">
              <span className="h-px w-6 md:w-12 bg-gradient-to-r from-transparent to-gray-300"></span>
              <span className="text-[10px] md:text-xs font-mono uppercase tracking-[0.2em] text-gray-400 whitespace-nowrap">
                {t('hero.tagline')}
              </span>
              <span className="h-px w-6 md:w-12 bg-gradient-to-l from-transparent to-gray-300"></span>
            </div>
          </Reveal>

          <Reveal delay={0.1}>
            <h1 className="text-5xl sm:text-6xl md:text-8xl font-bold tracking-tighter text-gray-900 mb-6 md:mb-8 leading-[0.95] select-none">
              {t('hero.title_line1')} <br />
              <span className="text-transparent bg-clip-text bg-gradient-to-br from-gray-900 via-gray-700 to-gray-500">
                {t('hero.title_line2')}
              </span>
            </h1>
          </Reveal>

          <Reveal delay={0.2}>
            <p className="text-lg md:text-xl text-gray-500 max-w-xl mx-auto mb-8 font-light leading-relaxed px-4 md:px-0">
              {t('hero.subtitle')}
            </p>
          </Reveal>

          <Reveal delay={0.3} width="100%">
            {/* Float animation wrapper */}
            <div className="w-full flex justify-center mt-8 md:mt-16 animate-float">
              <NeuralChat />
            </div>
          </Reveal>

        </div>

      </div>
    </section>
  );
};
